/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {financialYear as IFYear} from '../interface/Units';
import useCompanyStore from '../store/companyStore/companyDetailsStore';

const getYears = (data: string[]) => {
  const {preUnits} = useCompanyStore.getState();

  const type =
    preUnits?.financialYear?.valueOf() === IFYear?.JanDec?.valueOf()
      ? 'single'
      : 'double';

  if (!Array.isArray(data) || (type !== 'single' && type !== 'double')) {
    return [];
  }

  const years = data.map((year) => parseInt(year, 10)).sort((a, b) => a - b);

  if (type === 'single') {
    return years;
  } else {
    return years.slice(0, -1).map((year, i) => `${year}-${years[i + 1]}`);
  }
};

const yearFilterArray: (
  data: any,
  id?: string | undefined,
  showLeased?: boolean | undefined
) => any[] = (data: any, id = undefined, showLeased = undefined) => {
  if (!data || typeof data !== 'object') return [];

  // If no ID is provided, return all keys
  if (!id) {
    return Object.keys(data)
      .filter((key) => {
        return data[key].some((item: any) => {
          return showLeased !== undefined ? item.isLeased === showLeased : true;
        });
      })
      .map((item: any) => {
        return {value: item, label: item};
      }); // Convert string keys to numbers
  }

  // If ID is provided, find keys where arrays contain the matching ID
  return Object.keys(data)
    .filter((key) => {
      return data[key].some((item: any) => {
        return item._id === id && showLeased !== undefined
          ? item.isLeased === showLeased
          : item._id === id;
      });
    })
    .map((item: any) => {
      return {value: item, label: item};
    }); // Convert string keys to numbers
};

export default yearFilterArray;
